/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does the alpha channel do?`)
};

const es_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué hace el canal alfa?`)
};

const de_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was macht der Alpha-Kanal?`)
};

const nl_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat doet het alfakanaal?`)
};

const fr_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que fait le canal alpha ?`)
};

const it_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa fa il canale alfa?`)
};

const pt_br2_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o canal alfa faz?`)
};

const pt_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que faz o canal alfa?`)
};

const ja_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アルファチャネルは何をしますか？`)
};

const zh_cv_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`透明度（alpha）通道的作用是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_faq4_q", locale)
	if (locale === "en") return en_cv_faq4_q(inputs)
	if (locale === "es") return es_cv_faq4_q(inputs)
	if (locale === "de") return de_cv_faq4_q(inputs)
	if (locale === "nl") return nl_cv_faq4_q(inputs)
	if (locale === "fr") return fr_cv_faq4_q(inputs)
	if (locale === "it") return it_cv_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_cv_faq4_q(inputs)
	if (locale === "pt") return pt_cv_faq4_q(inputs)
	if (locale === "ja") return ja_cv_faq4_q(inputs)
	return zh_cv_faq4_q(inputs)
};